import {Skeleton} from "@mui/material";
import React from "react";

export const FilterSearchSkeleton = () => (
	<Skeleton variant="rounded" height={48}/>
)

